import React, { FC, ReactNode } from 'react'

export interface IInputRowProps {
  labelSize: 'small' | 'medium'
  label: string
  children: ReactNode
}

const InputRow: FC<IInputRowProps> = ({ label, children, labelSize }) => {
  const labelClass = `csas-calc-controls-label csas-calc-controls-label-fixed-${labelSize}`

  return (
    <div className='csas-calc-row csas-half-in-mobile'>
      <div className={labelClass} data-testid='input-row'>
        {label}
      </div>
      {children}
    </div>
  )
}

export { InputRow }
